<template>
    <label :for="id" :class="getLabelClass()">{{ label }}</label>
    <div class="p-inputgroup">
        <DatePicker
            :id="id"
            :class="getInputClass()"
            :disabled="desabilita"
            :model-value="modelValue"
            :show-icon="showIcon"
            date-format="dd/mm/yy"
            v-bind="$attrs"
            @blur="$emit('blur')"
            @update:model-value="updateValueDate"
        />
    </div>
    <small class="p-error" v-if="temErro">{{ mensagemErro || '&nbsp;' }}</small>
</template>
<script>
import DatePicker from 'primevue/datepicker';

export default {
    components: { DatePicker },
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
        desabilita: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: [String, Date],
            default: '',
        },
        temErro: {
            type: Boolean,
            default: false,
        },
        mensagemErro: {
            type: String,
            default: '',
        },
    },
    emits: ['update:modelValue', 'blur'],
    data() {
        return {
            id: `input-${Math.random().toString(36).substring(2, 9)}`,
        };
    },
    methods: {
        updateValueDate(date) {
            this.$emit('update:modelValue', date);
        },
        getInputClass() {
            return {
                'p-invalid': this.temErro,
            };
        },
        getLabelClass() {
            return {
                'error-field-label': this.temErro,
                required: this.required,
            };
        },
    },
};
</script>
